import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'orderBy',
  pure: true
})
export class OrderByPipe implements PipeTransform {
  transform(records: Array<any>, args?: any): any {
    if ( ! records) return 0;

    records.sort(function(a, b){
      if (a[args.property] < b[args.property]) {
        return -1 * args.direction;
      } else if (a[args.property] > b[args.property]) {
        return 1 * args.direction;
      } else {
        return 0;
      }
    });


    // Тут бы надо добавить проверку на то, чтобы код ниже выполнялся только в отчётах reg_day, billing, domain_billing.
    
    // Чтобы ref.ref == 'Total' не сортировался, а всегда оставался в конце
    let index = 0,
        total = {};

    records.forEach(function (el, i) {
      if (el.ref && el.ref == 'Total') {
        index = i;
        total = el;
      }
    });

    records.splice(index, 1);
    records.push(total);

    return records;
  };
}
